/* import logoInvoice from 'assets/img/logos/logo-invoice.png'; */
import IconButton from 'components/common/IconButton';
import React, { useState } from 'react';
import { Alert, Card, Col, FormControl, InputGroup, Row, Table } from 'react-bootstrap';
/* import SimpleBarReact from 'simplebar-react'; */
import usePayment from './usePayment';
import Flex from 'components/common/Flex';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { convertToNumber, currency, numberToWords } from 'helpers/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Avatar from 'components/common/Avatar';
import { Link } from 'react-router-dom';
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
const status = {
 PENDING: 'info',
 APPROVED: 'success',
 DECLINED: 'danger',
 ERROR: 'danger',
 EXPIRED: 'warning',
 VOIDED: 'danger'
};
const Invoice = () => {
 const { transaction, contract, id, goNavigate } = usePayment({ trans: true });
 const [value, setValue] = useState('');
 return (
  <>
   <Card className="mb-3">
    <Card.Body>
     <Row className="justify-content-between align-items-center">
      <Col xs>
       <h5 className={classNames('mb-2 mb-md-0', { 'd-none d-sm-block': !transaction?.id })}>Resumen</h5>
      </Col>
      <Col xs="auto">
       {transaction?.id ? (
        <>
         <IconButton
          variant="falcon-default"
          classText="d-none d-sm-block"
          size="sm"
          icon="file-pdf"
          className="me-1 mb-2 mb-sm-0"
          iconClassName="me-1"
         >
          Descarga (.pdf)
         </IconButton>
         <IconButton
          variant="falcon-default"
          classText="d-none d-sm-block"
          size="sm"
          icon="print"
          iconClassName="me-1"
          className="me-1 mb-2 mb-sm-0"
         >
          Imprimir
         </IconButton>
         <IconButton
          as={Link}
          size="sm"
          icon="dollar-sign"
          variant="falcon-success"
          className="mb-2 mb-sm-0"
          classText="d-none d-sm-block"
          to="/payments"
         >
          Hacer pago
         </IconButton>
        </>
       ) : (
        <Flex alignItems="center" justifyContent="end" wrap="wrap">
         <div className="p-1 flex-grow-1">
          <InputGroup className="">
           <FormControl
            size="sm"
            id="search"
            type="search"
            value={value}
            className="shadow-none"
            placeholder="Buscar ID de pago"
            onChange={({ target: { value } }) => setValue(value)}
           />
           <IconButton variant="falcon-primary" size="sm" icon="search" onClick={() => goNavigate(value)} />
          </InputGroup>
         </div>
         <div className="p-1">
          <IconButton
           as={Link}
           size="sm"
           icon="dollar-sign"
           variant="falcon-success"
           classText="d-none d-sm-block"
           to="/payments"
          >
           Hacer pago
          </IconButton>
         </div>
        </Flex>
       )}
      </Col>
     </Row>
    </Card.Body>
   </Card>
   {transaction?.id ? (
    <Card className="mb-3">
     <Card.Body>
      <Row className="align-items-center text-center mb-3">
       <Col sm={6} className="text-sm-start">
        <img src={contract?.emitters[0]?.logo} alt="invoice" width={150} />
       </Col>
       <Col className="text-sm-end mt-3 mt-sm-0">
        <h2 className="mb-3">Recibo</h2>
        <h5 className="text-capitalize">{contract?.emitters[0]?.name.toLowerCase()}</h5>
        <p className="fs--1 mb-0">
         {contract?.emitters[0]?.mail} <br /> Nit - {contract?.emitters[0]?.nit}
        </p>
       </Col>
       <Col xs={12}>
        <hr />
       </Col>
      </Row>
      <Row className="align-items-center">
       <Col xs={12}>
        <Alert variant={status[transaction?.status]}>
         <Flex alignItems="center" wrap="wrap-reverse" justifyContent="end" className="">
          <div className="flex-grow-1">
           <p className="m-0">
            Mensaje de <Alert.Link>{transaction?.status.toLowerCase()}</Alert.Link> en la transaccion.{' '}
            {transaction?.status_message}
           </p>
          </div>
          <div>
           <Alert.Heading className="text-end fw-bold m-0">{transaction?.status}</Alert.Heading>
          </div>
         </Flex>
        </Alert>
       </Col>
       <Col>
        <h6 className="text-500">Pagador</h6>
        <h5 className="text-capitalize">{transaction?.customer_data?.full_name.toLowerCase()}</h5>
        <p className="fs--1">
         {transaction?.customer_data['legal-id-type']} {transaction?.customer_data['legal-id']}
         <br />
         {transaction?.customer}
         <br />
         Metodo utilizado {transaction?.payment_method_type}
        </p>
        <p className="fs--1">
         <a href={`mailto:${transaction?.customer_data?.email}`}>{transaction?.customer_data?.email}</a>
         <br />
         <a href={`tel:${transaction?.customer_data?.phone_number}`}>{transaction?.customer_data?.phone_number}</a>
        </p>
       </Col>
       <Col sm="auto" className="ms-auto">
        <div className="table-responsive">
         <Table borderless size="sm" className="fs--1">
          <tbody>
           <tr>
            <th className="text-sm-end">No:</th>
            <td>{transaction?.id}</td>
           </tr>
           <tr>
            <th className="text-sm-end">Ref:</th>
            <td>{transaction?.reference}</td>
           </tr>
           <tr>
            <th className="text-sm-end">Orden:</th>
            <td>{contract?._id}</td>
           </tr>
           <tr>
            <th className="text-sm-end">Fecha:</th>
            <td>{dayjs(transaction?.created_at).locale('es').format('llll')}</td>
           </tr>
           <tr>
            <th className="text-sm-end">Estado:</th>
            <td className="text-end fw-bold">{transaction?.status}</td>
           </tr>
           <tr className="alert alert-success fw-bold">
            <th className="text-sm-end">Monto:</th>
            <td className="text-end">{currency(convertToNumber(transaction?.amount_in_cents / 100), true)}</td>
           </tr>
          </tbody>
         </Table>
        </div>
       </Col>
      </Row>

      <div className="mt-4 fs--1">
       <Table striped className="border-bottom">
        <thead className="light">
         <tr className="bg-primary text-white dark__bg-1000">
          <th className="border-0">Detalle</th>
         </tr>
        </thead>
        <tbody>
         <tr>
          <td className="align-middle">
           <h6 className="mb-0 text-nowrap text-capitalize">
            {contract?.project?.detail
             ? contract?.project?.detail
             : contract?.project?.name?.toLowerCase() + ' ' + contract?._id?.slice(-4)}
           </h6>
           <p className="mb-0">Monto expresado en texto</p>
           <p className="fs--2 text-end m-0">{numberToWords(convertToNumber(transaction?.amount_in_cents / 100))}</p>
          </td>
         </tr>
        </tbody>
       </Table>
      </div>
     </Card.Body>
     <Card.Footer className="bg-light">
      <p className="fs--1 mb-0">
       <strong>Notas: </strong> Realmente apreciamos su negocio y si hay algo más que podamos hacer, ¡háganoslo saber!
      </p>
     </Card.Footer>
    </Card>
   ) : id ? (
    <Card className="bg-transparent shadow-none py-3">
     <Card.Body className="border-2 border-dashed border-400 border rounded text-center py-5">
      <div className="fs--1">
       <FontAwesomeIcon icon="exclamation-triangle" className="fs-6 mb-3" />
       <h5>
        ¡ID <strong className="fw-bold">{id}</strong> No Encontrado!
       </h5>
       <p className="mb-0">
        No se encontro ningun <strong className="fw-bold">pago</strong> con el ID{' '}
        <strong className="alert alert-success p-0 m-0 fw-bold">{id}</strong>. Verifica el <strong>ID</strong> de{' '}
        <strong>pago</strong> e intentalo nuevamente.
       </p>
      </div>
     </Card.Body>
    </Card>
   ) : (
    <Card className="bg-transparent shadow-none py-3">
     <Card.Body className="border-2 border-dashed border-400 border rounded text-center p-3 p-md-5">
      <Flex className="flex-md-nowrap" alignItems="center" justifyContent="center" wrap="wrap md-nowrap">
       <div className="flex-fill">
        <Avatar emoji="📋️" size="5xl" className="mb-4" />
       </div>
       <div className="flex-fill">
        <Flex alignItems="center" wrap="wrap" justifyContent="center">
         <FontAwesomeIcon icon="search" className="fs-5 me-md-3" />
         <div className="flex-grow-1 ps-md-3 border-md-start border-start-dark">
          <h4 className="mb-0 pe-md-3">
           <strong className="fw-bold">¡</strong>Encuentra tu <strong className="fw-bold">ID de pago!.</strong>
          </h4>
          <span className="pe-3 fs--1">
           Encuentra la tranquilidad financiera con el <strong>ID de Pago:</strong> Tu clave para el control total
          </span>
         </div>
        </Flex>

        <p className="mb-0 mt-3">
         Descubre la <strong className="fw-bold">clave</strong> para <strong className="fw-bold">rastrear tu pago </strong>
         en un instante. ¿Has perdido tu recibo o necesitas realizar un seguimiento de tu transacción? No te preocupes, todo lo
         que necesitas es el <strong className="fw-bold">ID de pago.</strong> ¡Encuéntralo y accede a toda la información que
         necesitas al alcance de tu mano! Busca tu <strong className="fw-bold">ID de pago.</strong> ahora y mantén el control de
         tus finanzas.
        </p>
       </div>
      </Flex>
     </Card.Body>
    </Card>
   )}
   ;
  </>
 );
};

export default Invoice;
